import { Record } from 'immutable';
import { createReducer } from 'app/utils/redux';
import { notify } from 'app/services/errorReporter';

export const SyncedStorage = new Record({
  initilized: false,
  wasStorageInitiallyAvailable: false,
  storage: undefined,
});

/**
 *  Returns a storage reducer
 *
 * @param {Object} INITIAL_STORAGE_STATE ImmutableJS Object, containing the initial state
 * @param {String} INIT String representing the INIT action
 * @param {String} SET_ITEM String representing the SET_ITEM action
 * @param {String} REMOVE_ITEM String representing the REMOVE_ITEM action
 */
export const storageReducers = (
  Storage,
  INIT,
  SET_ITEM,
  REMOVE_ITEM,
  CLEAR,
) => createReducer(new SyncedStorage({ storage: Storage }), {
  [INIT]: (state, { wasStorageInitiallyAvailable, storageCopy }) => {
    if (!state.initilized) {
      return state.withMutations(syncedStorage =>
        syncedStorage.set('initilized', true)
                     .set('wasStorageInitiallyAvailable', wasStorageInitiallyAvailable)
                     .update('storage', storage => storage.merge(storageCopy)));
    } else {
      const error = new Error('Tried to initilize storage more then once');
      notify(error, { name: 'Storage.initilization' });
      throw error;
    }
  },
  [SET_ITEM]: (state, { key, value }) =>
    state.update('storage', storage => storage.set(key, value)),
  [REMOVE_ITEM]: (state, { key }) => state.update('storage', storage => storage.set(key, null)),
  [CLEAR]: (state) => state.set('storage', Storage),
});
